import en from './en';

const locales = {
    en: {
        translation: en
    }
};

export default locales;